module.exports = __webpack_public_path__ + "static/media/pwc.5d9ab814.png";